import fp from 'lodash/fp';
import { data } from '@factorin/container.macro';

import { lookupTableReducer, reducePath } from 'Modules/core/redux';

import { storageActions } from './actions';


const defaultPathState = () => ({
    $errors: {},
});

const actionLookup = {
    [storageActions.initialize]: () => fp.mapValues(defaultPathState, data.domain),
    [storageActions.receive]: reducePath(fp.mergeWith(fp.assign)),
    [storageActions.receiveWithUpdate]: reducePath((state, elements) => ({
        ...state,
        ...elements,
    })),
    [storageActions.setError]: reducePath(({ $errors, ...state }, { id, error }) => ({
        ...state,
        $errors: {
            ...$errors,
            [id]: error,
        },
    })),
    [storageActions.resetError]: reducePath(({ $errors, ...state }, id) => ({
        ...state,
        $errors: fp.omit(id, $errors),
    })),
};

export const reducer = lookupTableReducer(defaultPathState, actionLookup);
